const translations = {
  es: {
    // Nav
    nav_panel: "Panel",
    nav_cierre: "Cierre de mes",
    nav_ventajas: "Ventajas",
    nav_objetivos: "Objetivos",
    nav_consultoras: "Consultoras",
    nav_jerarquia: "Jerarquía",
    nav_historico: "Histórico",
    nav_alertas: "Alertas",
    nav_subir: "Subir CSV",
    nav_usuarios: "Usuarios",
    nav_perfil: "Perfil",

    // Layout
    coordinadora: "Coordinador/a",
    periodo: "Periodo",
    consultoras: "consultoras",
    equipo: "Equipo",
    subir_primer_csv: "Subir primer CSV",
    modo_demo_activo: "Modo Demo: Activo",
    modo_demo_ocultar: "Modo Demo: Ocultar Datos",
    cerrar_sesion: "Cerrar sesión",
    todos_equipos: "Todos los equipos",
    todos_paises: "Todos los países",
    pais_es: "España",
    pais_pt: "Portugal",
    pais_label: "País",

    // Login
    login_titulo: "Bienvenida",
    login_subtitulo: "Accede a tu panel de seguimiento",
    email: "Email",
    contrasena: "Contraseña",
    entrando: "Entrando…",
    entrar: "Entrar",
    error_credenciales: "Email o contraseña incorrectos.",

    // Comunes
    guardar: "Guardar",
    guardando: "Guardando…",
    guardar_cambios: "Guardar cambios",
    cancelar: "Cancelar",
    editar: "Editar",
    eliminar: "Eliminar",
    crear: "Crear",
    cerrar: "Cerrar",
    buscar: "Buscar",
    filtrar: "Filtrar",
    cargando: "Cargando…",
    sin_datos: "Sin datos disponibles",
    error_cargar: "Error al cargar los datos",
    exito_guardar: "Datos guardados correctamente",
    confirmar_eliminar: "¿Seguro que quieres eliminar esto?",

    // Ventajas
    ventajas_titulo: "Programas de Ventajas",
    crear_programa: "Crear programa",
    editar_programa: "Editar programa de Ventajas",
    nombre_programa: "Nombre del programa",
    descripcion: "Descripción opcional",
    periodo_label: "Periodo",
    premios: "Premios",
    anadir_premio: "Añadir premio",
    requisitos: "Requisitos",
    sin_ventajas: "No hay programas de ventajas para este periodo.",
    pais_programa: "País del programa",
    error_pais_requerido: "Debes seleccionar un país para este programa",

    // Consultoras
    consultoras_titulo: "Consultoras",
    buscar_consultora: "Buscar consultora…",
    activas: "Activas",
    inactivas: "Inactivas",
    en_riesgo: "En riesgo",
    rango: "Rango",
    ventas_personales: "Ventas pers.",
    ventas_equipo: "Ventas equipo",
    directas_activas: "Directas activas",
    ultimo_pedido: "Último pedido",

    // Dashboard
    dashboard_titulo: "Panel de control",
    total_consultoras: "Total consultoras",
    consultoras_activas: "Consultoras activas",
    ventas_totales: "Ventas totales",
    comisiones: "Comisiones",
    promociones: "Promociones disponibles",

    // Alertas
    alertas_titulo: "Alertas",
    en_riesgo_de_bajar: "En riesgo de bajar",
    cerca_de_ascender: "Cerca de ascender",
    cumplen_requisitos: "Cumplen requisitos para subir",

    // Usuarios
    usuarios_titulo: "Gestión de usuarios",
    nuevo_usuario: "Nuevo usuario",
    nombre: "Nombre",
    rol: "Rol",
    activo: "Activo",
    inactivo: "Inactivo",
    editar_usuario: "Editar usuario",
    crear_usuario: "Crear usuario",
    contrasena_nueva: "Contraseña (dejar vacío para no cambiar)",
    id_consultor: "ID Consultor (solo coordinadores)",
    email_hesttya: "Email en app.hesttya.pt",
    contrasena_hesttya: "Contraseña en app.hesttya.pt",
    error_cargar_usuarios: "Error al cargar usuarios",
    error_guardar_usuario: "Error al guardar usuario",
    error_eliminar_usuario: "Error al eliminar usuario",

    // Sincronización
    sincronizar: "Sincronizar",
    sincronizando: "Sincronizando…",
    sync_ok: "Sincronización completada",
    sync_error: "Error al sincronizar con Hesttya",
    auto_sync: "Auto-sincronización",
    activar_auto_sync: "Activar auto-sync",
    desactivar_auto_sync: "Desactivar auto-sync",

    // Objetivos
    objetivos_titulo: "Objetivos",
    nuevo_objetivo: "Nuevo objetivo",
    meta: "Meta",
    metrica: "Métrica",
    nota: "Nota",

    // Histórico
    historico_titulo: "Histórico",

    // Cierre de mes
    cierre_titulo: "Cierre de mes",
    ascenso_inminente: "Ascenso inminente",
    riesgo_descenso: "Riesgo de descenso",
    sin_actividad: "Sin actividad",

    // Jerarquía
    jerarquia_titulo: "Jerarquía del equipo",

    // Perfil
    perfil_titulo: "Mi perfil",
    cambiar_contrasena: "Cambiar contraseña",
    contrasena_actual: "Contraseña actual",
    nueva_contrasena: "Nueva contraseña",
    confirmar_contrasena: "Confirmar contraseña",

    // Roles (para mostrar en UI)
    rol_superadmin: "Superadmin",
    rol_admin: "Administrador",
    rol_marketing: "Marketing",
    rol_coordinador: "Coordinador",
  },

  pt: {
    // Nav
    nav_panel: "Painel",
    nav_cierre: "Fecho do mês",
    nav_ventajas: "Vantagens",
    nav_objetivos: "Objetivos",
    nav_consultoras: "Consultoras",
    nav_jerarquia: "Hierarquia",
    nav_historico: "Histórico",
    nav_alertas: "Alertas",
    nav_subir: "Carregar CSV",
    nav_usuarios: "Utilizadores",
    nav_perfil: "Perfil",

    // Layout
    coordinadora: "Coordenador/a",
    periodo: "Período",
    consultoras: "consultoras",
    equipo: "Equipa",
    subir_primer_csv: "Carregar primeiro CSV",
    modo_demo_activo: "Modo Demo: Ativo",
    modo_demo_ocultar: "Modo Demo: Ocultar Dados",
    cerrar_sesion: "Terminar sessão",
    todos_equipos: "Todas as equipas",
    todos_paises: "Todos os países",
    pais_es: "Espanha",
    pais_pt: "Portugal",
    pais_label: "País",

    // Login
    login_titulo: "Bem-vinda",
    login_subtitulo: "Acede ao teu painel de acompanhamento",
    email: "Email",
    contrasena: "Palavra-passe",
    entrando: "A entrar…",
    entrar: "Entrar",
    error_credenciales: "Email ou palavra-passe incorretos.",

    // Comunes
    guardar: "Guardar",
    guardando: "A guardar…",
    guardar_cambios: "Guardar alterações",
    cancelar: "Cancelar",
    editar: "Editar",
    eliminar: "Eliminar",
    crear: "Criar",
    cerrar: "Fechar",
    buscar: "Pesquisar",
    filtrar: "Filtrar",
    cargando: "A carregar…",
    sin_datos: "Sem dados disponíveis",
    error_cargar: "Erro ao carregar os dados",
    exito_guardar: "Dados guardados com sucesso",
    confirmar_eliminar: "Tens a certeza que queres eliminar isto?",

    // Ventajas
    ventajas_titulo: "Programas de Vantagens",
    crear_programa: "Criar programa",
    editar_programa: "Editar programa de Vantagens",
    nombre_programa: "Nome do programa",
    descripcion: "Descrição opcional",
    periodo_label: "Período",
    premios: "Prémios",
    anadir_premio: "Adicionar prémio",
    requisitos: "Requisitos",
    sin_ventajas: "Não há programas de vantagens para este período.",
    pais_programa: "País do programa",
    error_pais_requerido: "Deves selecionar um país para este programa",

    // Consultoras
    consultoras_titulo: "Consultoras",
    buscar_consultora: "Pesquisar consultora…",
    activas: "Ativas",
    inactivas: "Inativas",
    en_riesgo: "Em risco",
    rango: "Nível",
    ventas_personales: "Vendas pess.",
    ventas_equipo: "Vendas equipa",
    directas_activas: "Diretas ativas",
    ultimo_pedido: "Último pedido",

    // Dashboard
    dashboard_titulo: "Painel de controlo",
    total_consultoras: "Total de consultoras",
    consultoras_activas: "Consultoras ativas",
    ventas_totales: "Vendas totais",
    comisiones: "Comissões",
    promociones: "Promoções disponíveis",

    // Alertas
    alertas_titulo: "Alertas",
    en_riesgo_de_bajar: "Em risco de descer",
    cerca_de_ascender: "Perto de subir",
    cumplen_requisitos: "Cumprem requisitos para subir",

    // Usuarios
    usuarios_titulo: "Gestão de utilizadores",
    nuevo_usuario: "Novo utilizador",
    nombre: "Nome",
    rol: "Função",
    activo: "Ativo",
    inactivo: "Inativo",
    editar_usuario: "Editar utilizador",
    crear_usuario: "Criar utilizador",
    contrasena_nueva: "Palavra-passe (deixar vazio para não alterar)",
    id_consultor: "ID Consultora (só coordenadores)",
    email_hesttya: "Email em app.hesttya.pt",
    contrasena_hesttya: "Palavra-passe em app.hesttya.pt",
    error_cargar_usuarios: "Erro ao carregar utilizadores",
    error_guardar_usuario: "Erro ao guardar utilizador",
    error_eliminar_usuario: "Erro ao eliminar utilizador",

    // Sincronización
    sincronizar: "Sincronizar",
    sincronizando: "A sincronizar…",
    sync_ok: "Sincronização concluída",
    sync_error: "Erro ao sincronizar com Hesttya",
    auto_sync: "Auto-sincronização",
    activar_auto_sync: "Ativar auto-sync",
    desactivar_auto_sync: "Desativar auto-sync",

    // Objetivos
    objetivos_titulo: "Objetivos",
    nuevo_objetivo: "Novo objetivo",
    meta: "Meta",
    metrica: "Métrica",
    nota: "Nota",

    // Histórico
    historico_titulo: "Histórico",

    // Cierre de mes
    cierre_titulo: "Fecho do mês",
    ascenso_inminente: "Subida iminente",
    riesgo_descenso: "Risco de descida",
    sin_actividad: "Sem atividade",

    // Jerarquía
    jerarquia_titulo: "Hierarquia da equipa",

    // Perfil
    perfil_titulo: "O meu perfil",
    cambiar_contrasena: "Alterar palavra-passe",
    contrasena_actual: "Palavra-passe atual",
    nueva_contrasena: "Nova palavra-passe",
    confirmar_contrasena: "Confirmar palavra-passe",

    // Roles (para mostrar en UI)
    rol_superadmin: "Superadmin",
    rol_admin: "Administrador",
    rol_marketing: "Marketing",
    rol_coordinador: "Coordenador",
  },
};

export function getTranslations(lang) {
  return translations[lang] || translations.es;
}

export function makeTFunc(lang) {
  const dict = getTranslations(lang);
  return (key, fallback) => dict[key] ?? fallback ?? key;
}
